import React, { useCallback } from "react";
import { twMerge } from "tailwind-merge";

import SupDotsHorizontalRounded from "../../../icons/DotsHorizontalRounded";

interface MoreProps {
  active?: boolean;
  onClick?: (active: boolean) => void;
  className?: string;
}

const STYLES = {
  default: "text-neutral-900 bg-neutral-50",
  active: "text-neutral-25 bg-neutral-800",
};

export function SupMore({ active = false, onClick, className }: MoreProps) {
  const handleClick = useCallback(() => {
    onClick?.(active);
  }, [active, onClick]);

  return (
    <button className={twMerge("sup-more px-1 border-0.5 border-current h-4", active ? STYLES.active : STYLES.default, className)} onClick={handleClick}>
      <SupDotsHorizontalRounded height="1rem" width="1rem" className="scale-125" />
    </button>
  );
}
